<template>
  <LineChartGenerator
    :options="chartOptions"
    :data="data"
    :styles="styles"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs'
// import annotationPlugin from 'chartjs-plugin-annotation';
import 'chartjs-adapter-moment'
import zoomPlugin from 'chartjs-plugin-zoom'

import {
  Chart as ChartJS,
  Title,
  Tooltip,

  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  TimeScale
} from 'chart.js'

ChartJS.register(  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  // annotationPlugin,
  TimeScale,
  CategoryScale,
  zoomPlugin
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Inserte el título'
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
    chartOptions() {
      let options = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 0.5,
        animation: false,
        plugins:{
          title: {
            display: true,
            text: this.title,
          },
          datalabels: {
            display: false,
          },
           zoom: {
            pan: {
              enabled: true,
              mode: 'x',   // mover en eje X (puedes poner 'xy')
            },
            zoom: {
              wheel: {
                enabled: true,  // zoom con scroll
              },
              pinch: {
                enabled: true,  // zoom con dedos en pantallas táctiles
              },
              mode: 'x',        // solo eje X, o 'xy' si quieres ambos
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            time: {
              parser: 'YYYY-MM-DDTHH:mm:ss.SSS', // formato ISO de tu Python
              tooltipFormat: 'DD MMM YYYY HH:mm:ss', // formato en tooltip
              displayFormats: {
                day: 'DD MMM YYYY HH:mm:ss',   // cada tick diario
                hour: 'DD MMM YYYY HH:mm:ss',  // cada tick horario
                minute: 'DD MMM YYYY HH:mm:ss' // cada tick por minuto
              }
            }
          }
        }
      }
      return options
    }
  },
}
</script>
